<div class="searchbar-whereapp">
  <button
    mat-flat-button
    id="back-toolbar-button"
    (click)="onBackButtonClick()"
  >
    <mat-icon [inline]="true">chevron_left</mat-icon>
    Indietro
  </button>
</div>

<mat-progress-bar
  mode="indeterminate"
  style="position: absolute; top: 68px; z-index: 27"
  [hidden]="!this.loading"
>
</mat-progress-bar>

<div id="main-container">
  <!-- {{ messageDetail | json }} -->
  <div *ngIf="messageDetail" class="mat-typography">
    <h3>Mittente: {{ messageDetail.senderName }}</h3>
    <div class="row">
      <h1>
        <i
          *ngIf="messageDetail.validity === 1"
          matTooltip="{{ 'Multilang.verification1' | translate }}"
          class="fa fa-clock-o mr-2"
          id="pending-icon"
          aria-hidden="true"
        ></i>
        <i
          *ngIf="messageDetail.validity === 2"
          matTooltip="{{ 'Multilang.verification2' | translate }}"
          class="fa fa-arrow-right mr-2"
          id="active-icon"
          aria-hidden="true"
        ></i>
        <i
          *ngIf="messageDetail.validity === 3"
          matTooltip="{{ 'Multilang.verification3' | translate }}"
          class="fa fa-check mr-2"
          id="expired-icon"
          aria-hidden="true"
        ></i>
        <i
          *ngIf="messageDetail.validity === 4"
          style="color: crimson"
          matTooltip="{{ 'Multilang.verification4' | translate }}"
          class="fa fa-close mr-2"
          id="cancelled-icon"
          aria-hidden="true"
        ></i>
        {{ messageDetail.subject }}
      </h1>
      <!--<button *ngIf="(messageDetail.validity == 1 || messageDetail.validity == 2)" style="margin-right: 10px;margin-left: 10px;transform: translateY(-4px)" mat-stroked-button (click)="extendMessage(messageDetail)"
                [disabled]="!(messageDetail.validity == 1 || messageDetail.validity == 2)">Proroga
                messaggio</button><br><br>-->
      <button
        *ngIf="!(messageDetail.validity === 4 || messageDetail.validity === 3)"
        style="
          margin-right: 10px;
          margin-left: 10px;
          transform: translateY(-4px);
        "
        #terminateButton
        mat-stroked-button
        color="warn"
        (click)="terminateMessage(messageDetail.id)"
        [disabled]="
          messageDetail.validity === 4 || messageDetail.validity === 3
        "
      >
        Annulla messaggio
      </button>
    </div>
    <h3>Categoria: {{ messageDetail.categoryName }}</h3>
    <h3>
      Inviati: {{ messageDetail.messagesSent }} &nbsp; Visualizzati:
      {{ messageDetail.messagesRead }} &nbsp; Prezzo:
      {{ messageDetail.prezzo | currency : "EUR" : true }}
    </h3>
    <h3>Data creazione: {{ messageDetail.createdDate | date : "short" }}</h3>
    <h3>
      Valido da {{ messageDetail.startDate | date : "EEEE dd/LL/y HH:mm" }} a
      {{ messageDetail.endDate | date : "EEEE dd/LL/y HH:mm" }}
    </h3>

    <br /><br />
    <div class="section">
      <h4>Testo: {{ messageDetail.body }}</h4>
      <a
        *ngIf="messageDetail.multimediaLink.length > 0"
        mat-stroked-button
        href="{{ messageDetail.multimediaLink }}"
        target="_blank"
        [disabled]="!messageDetail.multimediaLink"
        >Visualizza multimedia</a
      >
      <br /><br />
      <h4 *ngIf="messageDetail.url">
        Url:
        <a href="{{ messageDetail.url }}" target="_blank">{{
          messageDetail.url
        }}</a>
      </h4>
    </div>
    <div class="section justify-center">
      <app-detail-map-v2
        *ngIf="
          messageDetail.messageTypeId == 1 || messageDetail.messageTypeId == 2
        "
        [aree]="messageDetail.area"
        [sideLength]="'600px'"
      ></app-detail-map-v2>
      <app-detail-map-byradius
        *ngIf="messageDetail.messageTypeId == 4 && showMap"
        [circle]="circle"
        [sideLength]="'600px'"
      >
      </app-detail-map-byradius>
    </div>
  </div>
</div>

<div class="loading" *ngIf="sub === true"></div>
